import React, { useState, useEffect } from "react";
import axios from "axios";
import { Box, Flex, Text, List, Button, Modal } from "@mantine/core";
import { IconAlertTriangleFilled } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";

export default function DealerWarnings({ reqData }) {
  const { t } = useTranslation();
  const [warnings, setWarnings] = useState([]);
  const [isOpen, setOpen] = useState(false);

  useEffect(() => {
    fetchWarnings();
  }, []);

  function fetchWarnings() {
    const req = {
      ...reqData,
    };

    axios
      .post("/ride-challenge/retrieve-warnings/", req)
      .then(({ data }) => {
        setWarnings(data.response);
      })
      .catch((err) => {
        setWarnings([]);
      });
  }

  function onClose() {
    setOpen(false);
  }

  if (!warnings.length) return null;

  return (
    <Box mt="xs">
      <Flex justify="center">
        <Button
          leftSection={<IconAlertTriangleFilled size={16} />}
          size="xs"
          variant="light"
          color="yellow"
          onClick={() => setOpen(true)}
          radius="xl"
        >
          {t("microsite:dealer_warning_button_text")}
        </Button>
      </Flex>
      <Modal opened={isOpen} onClose={onClose}>
        <Text mb="lg" fw={600}>
          {t("microsite:dealer_warning_modal_title")}
        </Text>
        <List>
          {warnings.map((warning, i) => (
            <List.Item key={i}>{warning}</List.Item>
          ))}
        </List>
      </Modal>
    </Box>
  );
}
